import { Primitive } from "./TransactionTemplate.types";

export const STEP_PADDING = 40;
export const PRIMITIVE_WIDTH = 120;
export const PROCESS_WIDTH = 130;
export const STEP_MIN_WIDTH = 900;
export const STEP_HEIGHT = 250;
export const PRIMITIVE_HEIGHT = 80;
export const PRIMITIVE_GAP = 160;
export const BRANCH_YES_OFFSET = 90;
export const BRANCH_NO_OFFSET = 180;
export const DEFAULT_START_X = 200;
export const DEFAULT_START_Y = 70;
export const EVENT_X = 60;
export const EVENT_Y = 80;
export const Y_THRESHOLD = 60;

const SHAPE_TYPE_KEYWORDS: Record<string, Primitive["type"]> = {
  condition: "condition",
  if: "condition",
  loop: "loop",
  for: "loop",
  process: "process",
  subtransaction: "process",
};


export const getShapeType = (name: string): Primitive["type"] => {
  const lower = name.toLowerCase();
  for (const [keyword, type] of Object.entries(SHAPE_TYPE_KEYWORDS)) {
    if (lower.includes(keyword)) return type;
  }
  return "primitive";
};

export const ACTION_TYPE_TO_VISUAL: Record<string, Primitive["type"]> = {
  if: "condition",
  for: "loop",
  subtransaction: "process",
  function: "function",
  return: "return",
  break: "break",
  throw: "throw",
  primitive: "primitive",
};

export interface ShapeConfig {
  visualType: Primitive["type"];
  initialData: Record<string, any>;
}

export const getShapeConfig = (
  shapeType: string,
  shapeName: string,
): ShapeConfig => {
  const lower = shapeType.toLowerCase();
  const base = { _isNew: true };

  switch (lower) {
    case "condition":
    case "if":
    case "decision":
      return {
        visualType: "condition",
        initialData: { ...base, type: "if", cond: "" },
      };
    case "loop":
    case "for":
    case "foreach":
      return {
        visualType: "loop",
        initialData: { ...base, type: "for", id: "i", elems: "items" },
      };
    case "process":
    case "subtransaction":
    case "subprocess":
      return {
        visualType: "process",
        initialData: { ...base, type: "subtransaction", transactionId: 0 },
      };
    case "function":
      return {
        visualType: "primitive",
        initialData: {
          ...base,
          type: "function",
          func: "funcName",
          funcParams: [],
        },
      };
    case "return":
    case "end":
      return {
        visualType: "primitive",
        initialData: { ...base, type: "return", func: "" },
      };
    case "break":
      return {
        visualType: "primitive",
        initialData: { ...base, type: "break" },
      };
    case "throw":
    case "error":
      return {
        visualType: "primitive",
        initialData: {
          ...base,
          type: "throw",
          funcParams: ["Error message"],
        },
      };
    default: {
      const data: Record<string, any> = { ...base, type: "primitive" };
      if (shapeName && !shapeName.includes(" ")) {
        data.func = `${shapeName}()`;
      }
      return { visualType: "primitive", initialData: data };
    }
  }
};